export const types_act = [
  { id: 0, libelle: 'Toutes' },
  { id: 2, libelle: 'Open' },
  { id: 1, libelle: 'Fixe' }
]

export function timeFormat(hourFrom, hourTo, styled) {

  hourFrom = new Date(hourFrom)
  hourFrom.setHours(hourFrom.getHours() - 1)
  hourTo = new Date(hourTo)
  hourTo.setHours(hourTo.getHours() - 1)

  if(styled) {
    return <>de <b>{hourFrom.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}</b> à  <b>{hourTo.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}</b></>
  } else {
    return `de ${hourFrom.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })} à ${hourTo.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}`
  }
}